import { render, staticRenderFns } from "./UiDocs.vue?vue&type=template&id=ffa8f12a"
import script from "./UiDocs.vue?vue&type=script&lang=js"
export * from "./UiDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports